import { IComponentOptions } from 'angular';
import template from './gauge-chart-widget.html';
import controller from './gauge-chart-widget.controller';

// import './gauge-chart-widget.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
